export default class IssueProject {
  constructor(obj) {
    this.id = obj.id;
    this.path = obj.path;
  }
}



// WEBPACK FOOTER //
// ./boards/models/project.js